import {editSvg as Icon__small__editSvg} from '../Icon__small/Icon__small--edit.js'
import {editSvg as Icon__xsmall__editSvg} from '../Icon__xsmall/Icon__xsmall--edit.js'

export var edit = {
  name: 'edit',
  category: 'icon',
  colorable: true,
  svg: Icon__small__editSvg,
  alt: {
    Icon__small: Icon__small__editSvg,
    Icon__xsmall: Icon__xsmall__editSvg
  },
  combined: ['Icon__small', 'Icon__xsmall']
};
